<template>
  <ul >
    
    <li class="nav-item" >
      <b-link class="d-flex align-items-center" @click="$router.push({ name: 'home' })" >
        <IconApontamentos/>
        <span>Apontamentos</span>
      </b-link>
    </li>

    <div class="line"/>
    
    <component
      :is="resolveNavItemComponent(item)"
      v-for="item in items"
      :key="item.header || item.title"
      :item="item"
    />


    <b-dropdown-item link-class="d-flex align-items-center" @click="logout" class="item-logout">
      <IconLogout/>
      <span>{{$t("Logout")}}</span>
    </b-dropdown-item>
    

  </ul>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'
import { initialAbility } from '@/libs/acl/config'
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import { provide, ref } from '@vue/composition-api'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'
import VerticalNavMenuGroup from '../vertical-nav-menu-group/VerticalNavMenuGroup.vue'
import { BLink,BNavItemDropdown, BDropdownItem} from 'bootstrap-vue'
import useAppConfig from '@core/app-config/useAppConfig'
import Locale from '@core/layouts/components/app-navbar/components/Locale.vue'
import SiteSelect from '@core/layouts/components/app-navbar/components/SiteSelect.vue'
import IconProfile from '@/assets/images/pages/profile-icon.svg'
import IconSupport from '@/assets/images/pages/support-icon.svg'
import IconArrowDown from '@/assets/images/pages/arrow-down-icon.svg'
import IconDatabases from '@/assets/images/pages/database-icon.svg'
import IconLogout from '@/assets/images/pages/logout-icon.svg'
import IconApontamentos from '@/assets/images/pages/apontamentos-icon-vertical.svg'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
    BLink,
    Locale,
    SiteSelect,
    IconProfile,
    IconSupport,
    IconArrowDown,  
    IconDatabases,
    IconLogout,
    IconApontamentos
  },
  data(){
    return {
      sites: null,
    }
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  setup() {
    provide('openGroups', ref([]))
    const {isNavMenuHidden } = useAppConfig()


    return {
      resolveNavItemComponent, isNavMenuHidden
    }
  },
  created(){
      this.getSites()
  },
  methods: {
    logout(){
      useJwt.logout(this.$router.currentRoute.params.prefix).then(response =>{
          localStorage.removeItem('userData')
          localStorage.removeItem('sites')

          // Reset ability
          this.$ability.update(initialAbility)

          // Redirect to login page
          this.$router.push({ name: 'login' }).catch(() => {});
      }).catch(error => {
          // Remove accessToken from localStorage
          localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)

          // Remove userData from localStorage
          localStorage.removeItem('userData')
          localStorage.removeItem('sites')

          // Reset ability
          this.$ability.update(initialAbility)
           
          // Redirect to login page
          this.$router.push({ name: 'login' })
      })
    },
    getSites(){
      this.sites = JSON.parse(localStorage.getItem('sites'))
    },
    setSite(site){
        localStorage.setItem('currentSite', JSON.stringify(site))
        this.$router.go()
    },
    getIconColor(site){
    let currentSite = JSON.parse(localStorage.getItem('currentSite'))
    if (currentSite && currentSite.guid == site.guid)
        return "margin-right: 10px; color:#f4811f"
    return "margin-right: 10px;"
    },
    toggleOperatorMode(){
      // this.isNavMenuHidden = !this.isNavMenuHidden
      return this.$route.name.split('-')[0] == 'operator' ? this.$router.push({name: 'home', params: {prefix: this.prefix}}) : this.$router.push({name: 'operator', params: {prefix: this.prefix}})
    },
  },
}
</script>
<style lang="scss">
.line{
  width: 100%;
  height: 1px;
  background-color: #CFC4BE;
  margin: 12px 0;
}
.item-logout{
  position: absolute !important;
  bottom: 16px;
}

</style>
